import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import formats from '../../../../const/formats';
import {Environment} from '../../../../const/environment';
import platformNames from '../../../../const/platformNames';
import ReactTooltip from 'react-tooltip';
import capitalize from '../../../../services/mini/capitalize';

class BtnOptionsCommentItem extends React.Component {

    deleteBtnOptions = (e) => {
        const { optionsItem } = this.props;
        this.props.onDelete(optionsItem, e);
    }

    render() {
        const {
            optionsItem,
            project,
            platform
        } = this.props;

        let canNotDeleteVersionMsg = '';

        const tempEnvironments = [Environment.Staging, Environment.Testing, Environment.Production];

        const whereStylesAreUsed = [];

        for (let i = 0; i < tempEnvironments.length; i++) {
            const curEnvironment = tempEnvironments[i];
            const options = JSON.parse(project[`${curEnvironment}Options`] || null) || {};
            const keys = Object.keys(options);

            for (let j = 0; j < keys.length; j++) {
                if (keys[j] !== platform) {
                    if (options && options[keys[j]] && options[keys[j]].selectedBtnOptionId) {
                        if (options[keys[j]].selectedBtnOptionId === optionsItem.id) {
                            whereStylesAreUsed.push(`on ${platformNames[keys[j]]} platform in ${capitalize(curEnvironment)} environment`);
                        }
                    }
                }
            }
        }

        if (whereStylesAreUsed.length > 0) {
            canNotDeleteVersionMsg = `You can not delete this style because it is used: ${whereStylesAreUsed.join(', ')}`;
        }

        return (
            <div className="btn-options-comment-item">
                {(optionsItem.id === 'default') ?
                    <div
                        className="btn-options-comment-item_content default">
                        <div className="btn-options-comment-item_content_name">
                            {optionsItem.name}<i className="icon icon-alan-lock" />
                        </div>
                    </div> :
                    <div
                        className="btn-options-comment-item_content">
                        <div className="btn-options-comment-item_content_name">
                            {optionsItem.updateTs &&
                                <div className="btn-options-comment-item_content_date">
                                    {moment(+optionsItem.updateTs).format(formats.MMM_DD_hh_mm_a)}
                                </div>}
                            <div className="btn-options-comment-item_content_name_text"
                                title={optionsItem.name}>
                                {optionsItem.name}
                            </div>
                            <i
                                data-for="deleteStyleTooltip"
                                data-tip={canNotDeleteVersionMsg}
                                className={`icon icon-alan-trash ${canNotDeleteVersionMsg && 'disabled-with-cursor'}`}
                                onClick={canNotDeleteVersionMsg ? undefined : this.deleteBtnOptions} />
                            {canNotDeleteVersionMsg && <ReactTooltip
                                id="deleteStyleTooltip"
                                effect="solid"
                                place="top"
                                class="tutor-dark-tooltip"
                            />}
                        </div>
                    </div>}

            </div>
        );
    }
}

BtnOptionsCommentItem.propTypes = {
    optionsItem: PropTypes.object.isRequired,
    onDelete: PropTypes.func
};

export default BtnOptionsCommentItem;